import { render, staticRenderFns } from "./searchProject.vue?vue&type=template&id=b6df56ec&scoped=true"
import script from "./searchProject.vue?vue&type=script&lang=js"
export * from "./searchProject.vue?vue&type=script&lang=js"
import style0 from "./searchProject.vue?vue&type=style&index=0&id=b6df56ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6df56ec",
  null
  
)

export default component.exports